import { render, staticRenderFns } from "./jss-default.vue?vue&type=template&id=462b1dc5&"
import script from "./jss-default.vue?vue&type=script&lang=js&"
export * from "./jss-default.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports